import { NgModule } from '@angular/core';
import { FilterSelectComponent } from './components/filter-select/filter-select.component';
import { GenericFilterComponent } from './generic-filter-panel.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { EbrCoreModule } from "../../core/components/ebr-core.module";
import { CommonModule } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { AccountSpecificFilterComponent } from './components/account-specific-filter/account-specific-filter.component';
import { SaveFilterListLinkComponent } from './components/save-filter-list-link/save-filter-list-link.component';
import { FilterNamePanelComponent } from './components/filter-name-panel/filter-name-panel.component';
import { FilterRecallPanelComponent } from './components/filter-recall-panel/filter-recall-panel.component';
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';

const CUSTOM_DATE_FORMAT = {
  parse: {
    dateInput: 'MMM-YYYY',
  },
  display: {
    dateInput: 'MMM-YYYY', //format used for displaying selected date in the input
  },
};
@NgModule({
    bootstrap: [],
    declarations: [
        AccountSpecificFilterComponent,
        GenericFilterComponent,
        FilterSelectComponent,
        SaveFilterListLinkComponent,
        FilterNamePanelComponent,
        FilterRecallPanelComponent,
    ],
    exports: [
        AccountSpecificFilterComponent,
        GenericFilterComponent,
        FilterSelectComponent,
        SaveFilterListLinkComponent,
        FilterNamePanelComponent,
        FilterRecallPanelComponent,
    ],
    providers: [
        {provide: DateAdapter, useClass: MomentDateAdapter},
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT }
    ],
    imports: [
        FormsModule,
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        ScrollingModule,
        EbrCoreModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatDatepickerModule,
        MatNativeDateModule, ReactiveFormsModule,
        MatMomentDateModule
    ]
})
export class GenericFilterPanelModule { }
